import React, { Fragment } from "react";
import CompliantInfo from "./CompliantInfo";
import { searchStore } from "features/ProductSearch/SearchStore";
import { observer } from "mobx-react-lite";
import ProductRow from "./ProductRow";
import { InternalProductSearchOutput } from "api-client";
import clsx from "clsx";
import Tooltip from "components/Tooltip";

interface SettingItem {
  name: React.ReactElement | string;
  icon: React.ReactElement;
  onClick: () => void;
  className: string;
  disabled?: boolean;
  hidden?: boolean;
}

export interface RowsListProps {
  match?: (product_id: string) => Promise<void>;
  settingsItems?: (
    product: InternalProductSearchOutput | null | undefined
  ) => SettingItem[];
  containerClassName?: string;
}

function ProductRowsList(props: RowsListProps): React.ReactNode {
  const { compliantItemsInfo } = searchStore;
  const [isMappingInProgress, setIsMappingInProgress] = React.useState(false);

  const createSettings = (
    item: InternalProductSearchOutput | null | undefined
  ) => {
    const items = props.settingsItems?.(item)?.filter((rec) => !rec.hidden);
    if (!items) return;
    return (
      <div className="flex items-center ml-3">
        {items.map((rec, index) => (
          <Tooltip
            key={index}
            content={rec.name}
            hoverOnTooltip
            className={clsx(
              "flex items-center w-full py-2 cursor-pointer text-indigo-700",
              rec.className
            )}
          >
            <div
              className={
                rec.disabled ? "opacity-50 cursor-not-allowed" : "opacity-100"
              }
              onClick={() => !rec.disabled && rec.onClick()}
            >
              {rec.icon}
            </div>
          </Tooltip>
        ))}
      </div>
    );
  };

  return (
    <div className={props.containerClassName}>
      {searchStore.isUsedSearch === false && <CompliantInfo isCompliant />}
      {searchStore.searchResults.items.map((item, index) => {
        const nonCompliantStarted =
          !compliantItemsInfo.hasMore &&
          compliantItemsInfo.totalCompliant === index;
        return (
          <Fragment key={index}>
            {nonCompliantStarted ? <CompliantInfo isCompliant={false} /> : null}
            <ProductRow
              key={`${item.id}-${index}`}
              mappingProgress={isMappingInProgress}
              onMappingProgressChange={(isInProgress: boolean) => {
                setIsMappingInProgress(isInProgress);
              }}
              product={item}
              match={props.match}
              testID={`linkProduct_row_${index}`}
              settings={createSettings(item)}
            />
          </Fragment>
        );
      })}
    </div>
  );
}

export default observer(ProductRowsList);
